import { css } from 'styled-components';
import { ANIMATION_DURATION, BACKGROUND_COLOR, BORDER_RADIUS } from '../tokens';
export const triggerBorderRadius = ({ $fullWidth, }) => css `
    border-radius: ${$fullWidth ? 0 : BORDER_RADIUS.TRIGGER_ICON}px;
  `;
export const triggerIconWrapperInteractionsNative = ({ $panelActive, $pressed, }) => $panelActive
    ? null
    : css `
        background-color: ${$pressed
        ? BACKGROUND_COLOR.ACTIVE
        : BACKGROUND_COLOR.DEFAULT};
      `;
export const triggerIconWrapperInteractionsWeb = ({ $panelActive, }) => $panelActive
    ? css `
        transform: rotateZ(180deg);
        transition: background-color ${ANIMATION_DURATION * 0.4}ms linear
            ${ANIMATION_DURATION * 0.6}ms,
          transform ${ANIMATION_DURATION * 0.6}ms linear;
      `
    : css `
        transform: rotateZ(0deg);
        transition: background-color ${ANIMATION_DURATION * 0.4}ms linear,
          transform ${ANIMATION_DURATION * 0.6}ms linear
            ${ANIMATION_DURATION * 0.4}ms;
      `;
export const triggerWrapperInteractionsNative = ({ $pressed, }) => css `
  background-color: ${$pressed
    ? BACKGROUND_COLOR.ACTIVE
    : BACKGROUND_COLOR.DEFAULT};
`;
export const triggerWrapperInteractionsWeb = () => css `
  &:hover {
    background-color: ${BACKGROUND_COLOR.ACTIVE};
  }
`;
